function SessionForwardSendRequest(path, message, recipient, sessionProperties) {
    this.path = path;
    this.message = message;
    this.recipient = recipient;
    this.sessionProperties = sessionProperties;
}

module.exports = SessionForwardSendRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/send/session-forward-send-request.js
// module id = 313
// module chunks = 1